<template>
	<v-app-bar
		:clipped-left="$vuetify.breakpoint.lgAndUp"
		app
		color="blue darken-3"
		dark
	>
		<v-toolbar-title style="width: 300px" class="ml-0 pl-4">
			<v-app-bar-nav-icon @click.stop="setDrawer"></v-app-bar-nav-icon>
			<span class="hidden-sm-and-down">Snowy Horizon</span>
		</v-toolbar-title>
		<!-- <v-text-field
      flat
      solo-inverted
      hide-details
      prepend-inner-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>-->
		<v-spacer></v-spacer>
		<v-btn icon href="https://www.snowyhorizon.com/" target="_blank">
			<v-icon>public</v-icon>
		</v-btn>
		<v-btn icon>
			<v-icon>notifications</v-icon>
		</v-btn>
		<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<v-btn icon large v-on="on">
					<v-avatar size="32px" tile>
						<img src="../assets/user.jpg" alt="user" />
					</v-avatar>
				</v-btn>
			</template>
			<v-list dense>
				<!-- <v-list-item avatar @click="profile">
          <v-list-item-avatar>
            <v-icon>account_circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>-->
				<v-list-item avatar @click="changePassword">
					<v-list-item-avatar>
						<v-icon>vpn_key</v-icon>
					</v-list-item-avatar>
					<v-list-item-title>Change Password</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item avatar @click="logout">
					<v-list-item-avatar>
						<v-icon>power_settings_new</v-icon>
					</v-list-item-avatar>
					<v-list-item-title>Logout</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
export default {
	methods: {
		setDrawer() {
			this.$store.commit("base/TOGGLE_DRAWER");
		},
		changePassword() {
			this.$router.push("/account/changepassword");
		},
		profile() {
			console.log("Profile");
		},
		logout() {
			this.$store.dispatch("base/logout").then(() => {
				this.$router.push("/login");
			});
		},
	},
};
</script>
